export const MAX_TOKEN_AMOUNT = '922337203685.4775807';

export const MAX_INCENTIVES_TOKENS_PER_POOL = 4;

export const MAX_INCENTIVES_PER_TOKEN = 10;

// Concentrated pools at/above this version expose gauges_get_reward_configs,
// returning Map<Address, Vec<RewardConfig>> in a single call on the pool contract.
export const CONCENTRATED_REWARD_CONFIGS_VERSION = 210;

export enum CreateIncentiveStep {
    'market',
    'amount',
    'duration',
}

export enum IncentiveTab {
    current = 'current',
    upcoming = 'upcoming',
}

export const INCENTIVE_TAB_OPTIONS = [
    { value: IncentiveTab.current, label: 'Current' },
    { value: IncentiveTab.upcoming, label: 'Upcoming' },
];
